import { CommitmentsVersionsService_commitmentVersionsServiceGetLatest } from '@festina/life-general-types/life/hooks/CommitmentsVersionsService_commitmentVersionsServiceGetLatest'

export const useFetchCommitmentVersionLatestNoSuspense =
  CommitmentsVersionsService_commitmentVersionsServiceGetLatest.useQuery
